import { render, staticRenderFns } from "./EntitlementPage.vue?vue&type=template&id=a016ab32&scoped=true"
import script from "./EntitlementPage.vue?vue&type=script&lang=js"
export * from "./EntitlementPage.vue?vue&type=script&lang=js"
import style0 from "./EntitlementPage.vue?vue&type=style&index=0&id=a016ab32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a016ab32",
  null
  
)

export default component.exports